import React from "react"
import "./TiredSection.css"

const TiredSection = () => {
  return (
    <section className='tired-section section section-white'>
      <div className='container'>
        <div className='tired-content animate-fade-up'>
          <h2 className='section-title'>
            Tired of Building Someone Else&apos;s Dream?
          </h2>
          <p className='tired-lead'>
            You’ve spent years leading teams, hitting goals, and creating value
            — for someone else’s bottom line.
          </p>
          <div className='tired-grid'>
            <div className='tired-card'>
              <h3 className='tired-card-title'>When it&apos;s time to build</h3>
              <ul className='tired-list'>
                <li>Bloated franchise models demanding massive overhead</li>
                <li>“Go-it-alone” startups with high failure rates</li>
                <li>
                  Corporate ladders that lead to burnout instead of freedom
                </li>
              </ul>
            </div>
            <div className='tired-quote'>
              <p>
                It’s time to trade salary dependence for business ownership —
                without trading stability for chaos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TiredSection

